import { useEffect } from "react"
import { useBlocker } from "react-router-dom"
import { Button } from "@/shared/ui/button"
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogTitle,
} from "@/shared/ui/dialog"

export function UnsavedChangesGuard({ dirty }: { dirty: boolean }) {
	const blocker = useBlocker(dirty)
	useEffect(() => {
		const guard = (event: BeforeUnloadEvent) => {
			if (dirty) event.preventDefault()
		}
		window.addEventListener("beforeunload", guard)
		return () => window.removeEventListener("beforeunload", guard)
	}, [dirty])
	return (
		<Dialog
			open={blocker.state === "blocked"}
			onOpenChange={(open) => {
				if (!open && blocker.state === "blocked") blocker.reset()
			}}
		>
			<DialogContent>
				<DialogTitle>Есть несохранённые изменения</DialogTitle>
				<DialogDescription>
					Сохраните изменения перед выходом, чтобы не потерять введённые данные и выбранные файлы.
				</DialogDescription>
				<DialogFooter>
					<Button variant="outline" onClick={() => blocker.state === "blocked" && blocker.reset()}>
						Остаться
					</Button>
					<Button
						variant="destructive"
						onClick={() => blocker.state === "blocked" && blocker.proceed()}
					>
						Выйти без сохранения
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
